import { render, staticRenderFns } from "./Luckyc.vue?vue&type=template&id=747c261f&scoped=true&"
import script from "./Luckyc.vue?vue&type=script&lang=js&"
export * from "./Luckyc.vue?vue&type=script&lang=js&"
import style0 from "./Luckyc.vue?vue&type=style&index=0&id=747c261f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c261f",
  null
  
)

export default component.exports